/**
 * The typed confirmation in front of every delete (components/ui/ConfirmDelete.tsx): the delete
 * button works only once the word below has been typed by hand, so a stray click on a trash icon
 * can't delete anything.
 */

export const CONFIRM_WORD = "delete";

/** Typed as asked, case and outer spaces aside: phone keyboards capitalise a field's first letter
 *  and add a space after a picked word. */
export function confirmWordTyped(value: string): boolean {
  return value.trim().toLowerCase() === CONFIRM_WORD;
}

/** A `beforeinput` that isn't typing: pasted, dropped or yanked text ("insertFromPaste", …). */
export function isPastedInput(inputType: string): boolean {
  return inputType.startsWith("insertFrom");
}
